export interface CookieWriteOptions {
  maxAgeSeconds: number;
  domain?: string;
}

export function readCookie(name: string): string | null {
  if (typeof document === 'undefined' || !document.cookie) return null;
  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${escaped}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function writeCookie(name: string, value: string, options: CookieWriteOptions): void {
  if (typeof document === 'undefined') return;
  const isSecure = typeof window !== 'undefined' && window.location.protocol === 'https:';
  const parts: string[] = [`${name}=${encodeURIComponent(value)}`, `Path=/`, `Max-Age=${options.maxAgeSeconds}`, `SameSite=Lax`];
  if (options.domain) parts.push(`Domain=${options.domain}`);
  if (isSecure) parts.push('Secure');
  document.cookie = parts.join('; ');
}
